import { Button, Grid, DialogActions, Typography } from '@material-ui/core';
import ModalContainer from 'app/components/Modal/ModalContainer';
import {
    DELETE_INTEGRITY_WARNING_MESSAGE_MODAL,
} from 'features/settings/integrityManagement/helpers/integrityManagement.constants';

const IntegrityDeleteMessageModal = ({
    lessons,
    children,
    dispatchOnLoad,
}) => (
    <ModalContainer
        items={lessons}
        title=""
        height="0"
        overflowY='visible'
        onEnter={dispatchOnLoad}
        TriggerComponent={children}
        modalId={DELETE_INTEGRITY_WARNING_MESSAGE_MODAL}
        onNext={({ goNext }) => goNext()}
        onPrevious={({ goPrevious }) => goPrevious()}
        Actions={({ toggleModal }) => (
            <DialogActions>
                <Button color="primary" variant="contained" size="small" onClick={toggleModal} >
                    Close
                </Button>
            </DialogActions>
        )}
    >
        <Grid container spacing={2} >
            <Typography>
                The integrity has been successfully deleted.
            </Typography>
            <Typography>
                Please ensure the total category percentage is updated to 100%.
            </Typography>
        </Grid>

    </ModalContainer>
);


export default IntegrityDeleteMessageModal;